




















import { DateTime } from "luxon";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

const timeRegex =
  /^(?<h>([0-9])|(0[0-9])|(1[0-9])|(2[0-3])):(?<m>[0-5][0-9])?/;

@Component
export default class TimeField extends Vue {
  @Prop() value?: string | null;

  @Prop() label?: string;
  @Prop({ default: true }) outlined?: boolean;
  @Prop() dense?: boolean;
  @Prop({ default: false }) hideDetails?: boolean;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: false }) applyFormatingOnLoad?: boolean;

  @Prop({ default: () => [] }) rules?: ((val: any) => string | boolean)[];

  get placeholder() {
    return DateTime.local().toISOTime().substring(0, 5);
  }

  internalModel = "";

  @Watch("value", { immediate: true })
  inputValueChanged(fresh: string | null | undefined) {
    if (fresh && fresh !== this.format(this.internalModel)) {
      if (this.applyFormatingOnLoad){
        this.internalModel = this.format(fresh) ?? "";
      }
      else{
        this.internalModel = fresh;
      }
    }
    else if (!fresh){
      this.internalModel = "";
    }
  }

  handleKeypress(e: KeyboardEvent) {
    if (/\d/.test(e.key)) return;
    if (e.key === ":" && !this.internalModel.endsWith(":")) return;

    e.stopPropagation();
    e.preventDefault();
  }

  valueChanged() {
    const formatted = this.format(this.internalModel);

    if (!formatted && this.internalModel.length === 2) {
      if (Number.parseInt(this.internalModel) > 23) {
        const maxHours = 23;
        this.internalModel = maxHours.toString();
      }

      this.internalModel += ":";
    }

    if (this.internalModel && this.internalModel.endsWith("::")) {
      this.internalModel = this.internalModel.slice(
        0,
        this.internalModel.length - 1
      );
    }

    if (this.internalModel.length === 1) {
      const minHour = 2;
      if (Number.parseInt(this.internalModel).toString().charAt(0) > minHour.toString()) {
        this.internalModel = '0' + this.internalModel
        this.valueChanged()
      }
    }

    this.$emit("input", formatted);
  }

  onBlur() {
    this.internalModel = this.format(this.internalModel) ?? "";
  }

  format(s: string) {
    const match = timeRegex.exec(s);

    if (match) {
      let [hours, minutes] = [0, 0];

      hours = +(match.groups?.h ?? 0);
      minutes = +(match.groups?.m ?? 0);

      const zeroDigit = match.groups?.m;
      if (zeroDigit) {
        if (hours || minutes) {
          // prettier-ignore

          let newMinutes;

          if (zeroDigit?.charAt(0) === "0") {
            newMinutes = "0" + minutes.toString();
          } else {
            newMinutes = minutes;
          }

          if (Number.parseInt(zeroDigit?.charAt(0)) > 5) {
            newMinutes = "59";
          }

          const value = `${hours < 10 ? "0" : ""}${hours}:${newMinutes}`;
          return value;
        } else if (hours === 0 && minutes === 0) {
          return "00:00";
        }
      }
    }

    return null;
  }
}
